import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Image } from 'react-bootstrap';
import Close from '../../images/close-icon.svg';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../Firebase';
import { toast } from 'react-toastify';

const PasswordResetModal = ({ showModal, onClose, initialEmail = '' }) => {
  const [resetEmail, setResetEmail] = useState(initialEmail);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setResetEmail(initialEmail);
  }, [initialEmail, showModal]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleForgotPassword();
    }
  };

  const handleForgotPassword = async () => {
    if (!resetEmail) {
      toast.error('Please enter your email.');
      return;
    }

    setLoading(true);

    try {
      await sendPasswordResetEmail(auth, resetEmail);
      toast.success('Password reset email sent successfully!');
      onClose();  // Close the modal after successful email sent
    } catch (error) {
      toast.error('Failed to send reset email: ' + error.message);
      console.error("Reset error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={showModal}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      contentClassName="password-modal-content"
      dialogClassName="password-modal-dialog"
    >
      <button
        type="button"
        onClick={onClose}
        className="modal-close-floating"
        aria-label="Close"
        style={{ background: 'none', border: 'none' }}
      >
        <Image src={Close} alt="Close" />
      </button>

      <Modal.Body className="password-modal-body p-0">
        <div className="head-bg">
          <h5 className="password-modal-title">Lost your Password?</h5>
        </div>
        <div className="inner-modal-content">
          <p className="password-modal-description">
            No worries—we've got you covered! Just follow the steps to reset it and get back on track in no time.
          </p>

          <Form.Group className="mb-4 form-field" controlId="resetEmail">
            <Form.Label className="form-label">Enter Your Email</Form.Label>
            <Form.Control
              type="email"
              value={resetEmail}
              placeholder="johndoe@squch.com"
              onChange={(e) => setResetEmail(e.target.value)}
              onKeyPress={handleKeyPress}
              className="form-control custom-input"
              required
              disabled={loading}
            />
          </Form.Group>
        </div>

        <div className="d-flex gap-2 justify-content-end btn-footer">
          <Button variant="secondary" className="modal-btn cancel-btn" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button className="login-button m-0" onClick={handleForgotPassword} disabled={loading}>
            {loading ? 'Sending...' : 'Continue'}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PasswordResetModal;



// import React, { useState, useEffect } from 'react';
// import { Modal, Button, Form, Image } from 'react-bootstrap';
// import Close from '../../images/close-icon.svg';
// import { sendPasswordResetEmail, fetchSignInMethodsForEmail } from 'firebase/auth';
// import { auth } from '../../Firebase';
// import { toast } from 'react-toastify';

// const PasswordResetModal = ({ showModal, onClose, onSubmit, initialEmail = '' }) => {
//   const [resetEmail, setResetEmail] = useState(initialEmail);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     setResetEmail(initialEmail);
//   }, [initialEmail, showModal]);

//   const handleKeyPress = (e) => {
//     if (e.key === 'Enter') {
//       handleForgotPassword();
//     }
//   };

//   const handleForgotPassword = async () => {
//     if (!resetEmail) {
//       toast.error('Please enter your email.');
//       return;
//     }

//     setLoading(true);

//     try {
//       await sendPasswordResetEmail(auth, resetEmail);
//       toast.success('Password reset email sent successfully!');
//       if (onSubmit) onSubmit(resetEmail);
//       onClose();
//     } catch (error) {
//       toast.error('Failed to send reset email: ' + error.message);
//       console.error("Reset error:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Modal
//       show={showModal}
//       onHide={onClose}
//       centered
//       backdrop="static"
//       keyboard={false}
//       contentClassName="password-modal-content"
//       dialogClassName="password-modal-dialog"
//     >
//       <button
//         type="button"
//         onClick={onClose}
//         className="modal-close-floating"
//         aria-label="Close"
//         style={{ background: 'none', border: 'none' }}
//       >
//         <Image src={Close} alt="Close" />
//       </button>

//       <Modal.Body className="password-modal-body p-0">
//         <div className="head-bg">
//           <h5 className="password-modal-title">Lost your Password?</h5>
//         </div>
//         <div className="inner-modal-content">
//           <p className="password-modal-description">
//             No worries—we've got you covered! Just follow the steps to reset it and get back on track in no time.
//           </p>

//           <Form.Group className="mb-4 form-field" controlId="resetEmail">
//             <Form.Label className="form-label">Enter Your Email</Form.Label>
//             <Form.Control
//               type="email"
//               value={resetEmail}
//               placeholder="johndoe@squch.com"
//               onChange={(e) => setResetEmail(e.target.value)}
//               onKeyPress={handleKeyPress}
//               className="form-control custom-input"
//               required
//               disabled={loading}
//             />
//           </Form.Group>
//         </div>

//         <div className="d-flex gap-2 justify-content-end btn-footer">
//           <Button variant="secondary" className="modal-btn cancel-btn" onClick={onClose} disabled={loading}>
//             Cancel
//           </Button>
//           <Button className="login-button m-0" onClick={handleForgotPassword} disabled={loading}>
//             {loading ? 'Sending...' : 'Continue'}
//           </Button>
//         </div>
//       </Modal.Body>
//     </Modal>
//   );
// };

// export default PasswordResetModal;
